import React from 'react';

const Chip = (props) => (
  	<span className="mdl-chip mdl-chip--deletable">
    	<span className="mdl-chip__text">{props.text}</span>
    	<button onClick={props.onDelete} type="button" className="mdl-chip__action"><i className="material-icons">cancel</i></button>
	</span>
)

export default Chip


// WEBPACK FOOTER //
// ./src/components/form/Chip.js